module.exports = __webpack_public_path__ + "static/media/fasting-status-fasting.385ff994.svg";